import { clearSession, getAccessToken } from "./api/session";

class Auth {
  login(callback) {
    callback();
  }

  logout(callback) {
    clearSession();
    callback();
  }

  isAuthenticated() {
    return Boolean(getAccessToken());
  }
}

export default new Auth();
